import { CloseRounded, Search } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import classNames from 'classnames';
import React, { ChangeEvent, useState } from 'react';
import styles from './CollapsibleSearch.module.scss';

interface CollapsibleSearchProps {
    onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    placeholder?: string;
    defaultSearchTerm?: string | null;
    className?: string;
    onClose?: () => void;
}

export const CollapsibleSearch = ({
    onChange,
    placeholder,
    defaultSearchTerm,
    className,
    onClose,
}: CollapsibleSearchProps) => {
    const [isSearchOpen, setIsSearchOpen] = useState<boolean>(
        !!defaultSearchTerm
    );
    const [searchTerm, setSearchTerm] = useState<string | null>(
        defaultSearchTerm ?? ''
    );

    const handleChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        if (!event) {
            return;
        }
        setSearchTerm(event.target.value);

        onChange(event);
    };

    return (
        <div className={classNames(styles.container, className)}>
            {!isSearchOpen && (
                <IconButton
                    onClick={() => setIsSearchOpen(true)}
                    data-testid="collapsibleSearchButton"
                >
                    <Search />
                </IconButton>
            )}
            {isSearchOpen && (
                <div className={styles.searchInput}>
                    <TextField
                        data-testid="collapsibleSearchField"
                        onChange={(e) => handleChange(e)}
                        onBlur={() => {
                            if (!searchTerm) {
                                setIsSearchOpen(false);
                                onClose && onClose();
                            }
                        }}
                        value={searchTerm}
                        placeholder={placeholder ?? 'Search'}
                    />
                    {!!searchTerm && (
                        <IconButton
                            data-testid="collapsibleSearchClear"
                            className={styles.searchClose}
                            onClick={() => {
                                setSearchTerm('');
                                setIsSearchOpen(false);
                                onClose && onClose();
                            }}
                        >
                            <CloseRounded />
                        </IconButton>
                    )}
                </div>
            )}
        </div>
    );
};
